import { DailyCost } from './daily-cost.model';
import * as moment from 'moment';

export class INDRACalendarMonthlyCost {
	month: number;
	label: string;
	from: string;
	dailyCosts: DailyCost[][];
	date: Date;
	minCost: {
		currency: number,
		points: number
	};
	stepIndex?: number;

	constructor(month, monthLabel) {
		this.dailyCosts = [];
		this.month = month;
		this.label = monthLabel;
		this.minCost = { currency: null, points: null };
		// supply date prop for date-page.component.ts > INDRA_openSelectMonthModal > handleClose
		this.date = moment(monthLabel,'MMMM YYYY').toDate();
	}
}

